import { render, staticRenderFns } from "./403.vue?vue&type=template&id=f124b2ca&"
var script = {}
import style0 from "./403.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "403.vue"
export default component.exports